<template>
  <div style="width: 100%;">
    <div class="text-h5 text-center pb-4" v-if="isMobile">
      S'inscrire sur Indeego
    </div>
    <v-stepper
      v-model="step"
      flat
      style="background: transparent !important;"
    >
      <v-stepper-header style="box-shadow: none !important;">
        <v-stepper-step :complete="step > 1" color="accent" step="1" />

        <v-divider></v-divider>

        <v-stepper-step :complete="step > 2" color="accent" step="2" />

        <v-divider></v-divider>

        <v-stepper-step color="accent" step="3" />
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content class="pt-1" step="1">
          <personal-infos />
        </v-stepper-content>

        <v-stepper-content class="pt-1" step="2">
          <space-infos />
        </v-stepper-content>

        <v-stepper-content class="pt-1" step="3">
          <check-email />
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <div class="pb-4 text-center" v-if="isMobile">
      Vous avez déjà un compte ? <a href="https://www.indeego.fr/login" class="login-btn">Connectez-vous</a>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import PersonalInfos from './Signup/PersonalInfos.vue';
import SpaceInfos from './Signup/SpaceInfos.vue';
import CheckEmail from './Signup/CheckEmail.vue';

export default {
  computed: {
    ...mapState([
      `signupStep`,
    ]),
    isMobile() {
      return this.$vuetify.breakpoint.width <= 910;
    },
    step: {
      get() { return this.signupStep; },
      set(value) { return this.SET_SIGNUP_STEP(value); },
    },
  },

  methods: {
    ...mapMutations([
      `SET_SIGNUP_STEP`,
    ]),
    setStepFromRoute() {
      let step = 1;
      if (this.$route.name === `signupSpace`) {
        step = 2;
      } else if (this.$route.name === `signupCheckEmail`) {
        step = 3;
      }
      this.step = step;
    },
  },

  beforeMount() {
    this.setStepFromRoute();
  },

  watch: {
    $route() {
      this.setStepFromRoute();
    },
  },

  components: {
    PersonalInfos,
    SpaceInfos,
    CheckEmail,
  },
};
</script>

<style lang="scss">
// .stepper-header {
//   * {
//     color: $primaryColor !important;
//   }
// }
</style>
